import { useEffect, useState } from "react";
import { api } from "../../lib/auth";

export default function AdminInvoices() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/invoices").then((r) => setRows(r.data)); }, []);

  return (
    <div data-testid="admin-invoices-page" className="p-8 lg:p-10 max-w-[1400px]">
      <h1 className="font-display font-extrabold text-4xl text-black tracking-tight">Invoices</h1>
      <p className="text-black/60 mt-1.5 text-sm">Billing records issued to tenants.</p>

      <div className="mt-7 bg-white rounded-2xl border border-black/8 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#FFFCF2] text-black/55 text-[11px] uppercase tracking-wider">
            <tr>
              <th className="text-left p-4 font-bold">Invoice #</th>
              <th className="text-left p-4 font-bold">Tenant</th>
              <th className="text-left p-4 font-bold">Plan</th>
              <th className="text-left p-4 font-bold">Amount</th>
              <th className="text-left p-4 font-bold">Status</th>
              <th className="text-left p-4 font-bold">Issued</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-black/8">
            {rows.map((i) => (
              <tr key={i.id} className="hover:bg-[#FFFCF2]/60">
                <td className="p-4 font-mono text-xs text-black">{i.invoice_number}</td>
                <td className="p-4 font-semibold text-black">{i.tenant}</td>
                <td className="p-4 text-black/70">{i.plan}</td>
                <td className="p-4 tabular-nums">₦{Number(i.amount || 0).toLocaleString()}</td>
                <td className="p-4">
                  <span className={`text-[10px] font-bold uppercase px-2 py-1 rounded-md ${
                    i.status === "paid" ? "bg-[#E8F5E9] text-[#1FA868]" : "bg-[#FFF5D6] text-amber-700"
                  }`}>{i.status}</span>
                </td>
                <td className="p-4 text-black/60 text-xs">{(i.date || "").slice(0, 10)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan="6" className="p-10 text-center text-black/50">No invoices.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
